/*
 * @Author: your name
 * @Date: 2021-01-13 20:58:12
 * @LastEditTime: 2022-10-27 16:13:52
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\carInfo\config\visitorVehicleType.js
 */
const visitorTypeOption = function () {
  return {
    labelWidth: 140,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: "访客车辆类型名称",
        span: 24,
        prop: "name",
        labelWidth: 140,
        // disabled: true,
        rules: [
          {
            required: true,
            message: "请输入访客车辆类型名称",
            trigger: "change"
          }
        ]
      }
    ]
  };
};

export default visitorTypeOption;
